var ACCOUNT_NOT_FOUND_KEY = 'accountNotFound';
export var setAccountNotFound = function () {
    try {
        sessionStorage.setItem(ACCOUNT_NOT_FOUND_KEY, 'true');
    }
    catch (_a) { }
};
export var getAccountNotFound = function () {
    try {
        return sessionStorage.getItem(ACCOUNT_NOT_FOUND_KEY) === 'true';
    }
    catch (_a) {
        return false;
    }
};
export var clearAccountNotFound = function () {
    try {
        sessionStorage.removeItem(ACCOUNT_NOT_FOUND_KEY);
    }
    catch (_a) { }
};
